import React from 'react';
import { MobXProviderContext } from 'src/modules';
import store from 'src/stores';

export const useStores = (): typeof store => {
  return React.useContext(MobXProviderContext) as typeof store;
};
